/**
 * IngredientOrganicStatus - synchronized with the Prisma enum of the same name.
 *
 * Tri-state, never a boolean: art. 30 §2-§3 Reg. (UE) 2018/848 treats a
 * product "in conversione" differently from a fully organic one, and art. 30
 * §5 lett. b) requires the label to state the total percentage of organic
 * agricultural ingredients when the finished product is not entirely organic.
 * An ingredient still in conversion does NOT count toward that percentage's
 * numerator. A boolean `isOrganic` plus a separate `inConversion` flag would
 * admit a meaningless combination (both true) and would let a consumer of
 * this field forget to check the second flag, silently counting a
 * conversion-stage ingredient as organic.
 */
export const INGREDIENT_ORGANIC_STATUSES = ['NOT_ORGANIC', 'ORGANIC', 'IN_CONVERSION'] as const;
export type IngredientOrganicStatus = (typeof INGREDIENT_ORGANIC_STATUSES)[number];
